export default __webpack_public_path__ + "bf216b8c630ed1c67860fa5739b2c2b9.svg";